@use '@dixa/lib-shared-tokens/scss' as *;

.root {
  display: flex;
  column-gap: var(--dixa-size-spacer-400);
  padding: var(--dixa-size-spacer-300);
  align-items: center;
  justify-content: space-between;
  color: var(--dixa-typography-color-primary);
  font-weight: var(--dixa-typography-weight-semibold);
}

.header {
  display: grid;
  grid-auto-flow: column;
  line-height: 1.3;
  align-items: center;
  grid-gap: var(--dixa-size-spacer-200);

  label {
    margin-right: 0;
    cursor: pointer;
    color: var(--dixa-typography-color-primary);
    font-size: var(--dixa-typography-size-300);
  }
}

.helpIcon {
  color: var(--dixa-typography-color-secondary);
}
